// Translation service for multi-language support
const translations = {
  fr: {
    back: "Retour",
    loadingServices: "Chargement des services...",
    noServiceFound: "Aucun service trouvé",
    comeBackSoonActivities: "Revenez bientôt pour découvrir nos activités",
    noDescriptionAvailable: "Aucune description disponible",
    openingHours: "Horaires d'ouverture",
    opening: "Ouverture",
    closing: "Fermeture",
    getInformed: "S'informer",
    contact: "Contact",
    address: "Adresse",
    reservations: "Réservations",
    wifi: "Wi-Fi",
    followUs: "Suivez-nous",
    network: "Réseau",
    password: "Mot de passe",
    availableAtReception: "Disponible à la réception",
    addressLine1: "Avenue Mohamed V",
    addressLine2: "Tunis, Tunisie",
    allRightsReserved: "Tous droits réservés",
    createdBy: "Créé par",
  },
  en: {
    back: "Back",
    loadingServices: "Loading services...",
    noServiceFound: "No service found",
    comeBackSoonActivities: "Come back soon to discover our activities",
    noDescriptionAvailable: "No description available",
    openingHours: "Opening Hours",
    opening: "Opening",
    closing: "Closing",
    getInformed: "Get Informed",
    contact: "Contact",
    address: "Address",
    reservations: "Reservations",
    wifi: "Wi-Fi",
    followUs: "Follow Us",
    network: "Network",
    password: "Password",
    availableAtReception: "Available at reception",
    addressLine1: "Avenue Mohamed V",
    addressLine2: "1002 Tunis, Tunisia",
    allRightsReserved: "All rights reserved",
    createdBy: "Created by",
  },
  ar: {
    back: "رجوع",
    loadingServices: "جاري تحميل الخدمات...",
    noServiceFound: "لم يتم العثور على خدمة",
    comeBackSoonActivities: "عد قريبًا لاكتشاف أنشطتنا",
    noDescriptionAvailable: "لا يوجد وصف متاح",
    openingHours: "ساعات العمل",
    opening: "الافتتاح",
    closing: "الإغلاق",
    getInformed: "احصل على المعلومات",
    contact: "اتصل بنا",
    address: "العنوان",
    reservations: "الحجوزات",
    wifi: "واي فاي",
    followUs: "تابعونا",
    network: "الشبكة",
    password: "كلمة المرور",
    availableAtReception: "متوفرة في الاستقبال",
    addressLine1: "شارع محمد الخامس",
    addressLine2: "تونس، تونس",
    allRightsReserved: "جميع الحقوق محفوظة",
    createdBy: "تم إنشاؤه بواسطة",
  },
  es: {
    back: "Volver",
    loadingServices: "Cargando servicios...",
    noServiceFound: "No se encontró ningún servicio",
    comeBackSoonActivities: "Vuelve pronto para descubrir nuestras actividades",
    noDescriptionAvailable: "No hay descripción disponible",
    openingHours: "Horario de apertura",
    opening: "Apertura",
    closing: "Cierre",
    getInformed: "Manténgase Informado",
    contact: "Contacto",
    address: "Dirección",
    reservations: "Reservas",
    wifi: "Wi-Fi",
    followUs: "Síguenos",
    network: "Red",
    password: "Contraseña",
    availableAtReception: "Disponible en recepción",
    addressLine1: "Avenue Mohamed V",
    addressLine2: "Túnez, Túnez",
    allRightsReserved: "Todos los derechos reservados",
    createdBy: "Creado por",
  },
  de: {
    back: "Zurück",
    loadingServices: "Dienste werden geladen...",
    noServiceFound: "Kein Service gefunden",
    comeBackSoonActivities: "Kommen Sie bald wieder, um unsere Aktivitäten zu entdecken",
    noDescriptionAvailable: "Keine Beschreibung verfügbar",
    openingHours: "Öffnungszeiten",
    opening: "Öffnung",
    closing: "Schließung",
    getInformed: "Bleiben Sie Informiert",
    contact: "Kontakt",
    address: "Adresse",
    reservations: "Reservierungen",
    wifi: "WLAN",
    followUs: "Folgen Sie uns",
    network: "Netzwerk",
    password: "Passwort",
    availableAtReception: "An der Rezeption erhältlich",
    addressLine1: "Avenue Mohamed V",
    addressLine2: "Tunis, Tunesien",
    allRightsReserved: "Alle Rechte vorbehalten",
    createdBy: "Erstellt von",
  },
}

export default translations
